import React from 'react';
import { Box, Card, Grid, Skeleton, alpha, useTheme } from '@mui/material';

const SkeletonCard: React.FC<{ isOrgPays?: boolean }> = ({ isOrgPays = false }) => {
  const theme = useTheme();

  return (
    <Card
      variant='outlined'
      sx={{
        borderRadius: '10px',
        borderColor: 'transparent',
        backgroundColor: isOrgPays
          ? theme.palette.alternate.lightest
          : alpha(theme.palette.primary.main, 0.05),
        px: 2,
        py: 2.5,
      }}>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Box flex={1}>
          <Skeleton variant='text' width='40%' height={24} />
          <Skeleton variant='text' width='60%' height={18} />
        </Box>
        <Skeleton variant='rounded' width={130} height={32} sx={{ borderRadius: '16px', ml: 3 }} />
      </Box>
    </Card>
  );
};

const RevShareCardSkeleton: React.FC = () => (
  <Box>
    <Grid container>
      <Grid size={{ md: 12, lg: 10, xl: 8 }}>
        <Box display='flex' flexDirection='column' rowGap={5}>
          <Box display='flex' flexDirection='column' rowGap='15px'>
            <Box mb='5px'>
              <Skeleton variant='text' width={120} height={22} />
            </Box>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </Box>
          <Box display='flex' flexDirection='column' rowGap='15px'>
            <Box mb='5px'>
              <Skeleton variant='text' width={120} height={22} />
            </Box>
            <SkeletonCard isOrgPays />
            <SkeletonCard isOrgPays />
            <SkeletonCard isOrgPays />
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default RevShareCardSkeleton;
